import { axiosAuth } from "services/generic/AxiosInterceptor/AxiosInterceptor"

import { Duration } from "@shared/types/duration"

/**
 *  Helper function to create a POST request that is tied to a specific Request-Response pair.
 */
export function makeAuthPostRequest<TRequest, TResponse>(endpoint: string, timeout?: Duration) {
  return (data: TRequest) =>
    axiosAuth({
      url: endpoint,
      method: "post",
      data,
      timeout: timeout?.milliseconds,
    }).then((resp) => resp.data as TResponse)
}
